import styled from 'styled-components';

// Kolor „pierścienia" wokół awatara — musi zlewać się z tłem wiersza tabeli,
// żeby nachodzące na siebie kółka były wyraźnie odseparowane.
const ringColor = (mode: string) => (mode === 'dark' ? '#12171c' : '#ffffff');

export const Stack = styled.div<{ $clickable: boolean }>`
  display: inline-flex;
  align-items: center;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  /* Kolejne awatary nachodzą na poprzedni; pierwszy zostaje bez przesunięcia. */
  & > * + * {
    margin-left: -8px;
  }

  /* Inicjały wyśrodkowane w widocznej części kółka, a nie w całym kółku: prawą
     krawędź zasłania kolejny awatar i druga litera znikała pod spodem. */
  & > *:not(:last-child) {
    padding-right: 8px;
  }

  &:hover > * {
    ${({ $clickable }) => ($clickable ? 'margin-left: -4px;' : '')}
  }

  &:hover > *:first-child {
    margin-left: 0;
  }

  & > * {
    transition: margin-left 0.15s ease;
  }
`;

export const AvatarCircle = styled.span<{ $gradient: string; $photo?: string }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border-radius: 50%;
  overflow: hidden;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #ffffff;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.18);
  background: ${({ $gradient }) => $gradient};
  background-image: ${({ $photo, $gradient }) => ($photo ? `url(${$photo})` : $gradient)};
  background-size: cover;
  background-position: center;
  box-shadow: 0 0 0 2px ${({ theme }) => ringColor(theme.mode)};
`;

export const OverflowCircle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 6px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#4b5563')};
  background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.10)' : '#f3f4f6')};
  box-shadow: 0 0 0 2px ${({ theme }) => ringColor(theme.mode)};
`;

// Guzik „Dodaj pracowników" gdy zespół jest pusty — ten sam język wizualny
// co puste liczniki produktów i kategorii (przerywana ramka, stonowany kolor).
export const AddCta = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 28px;
  padding: 0 8px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 300;
  line-height: 1;
  /* Etykieta nigdy nie łamie się na dwie linie: w wierszu tabeli rozjeżdżało to
     wysokość komórki i wypychało sąsiednie kolumny. */
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.15s ease;
  background: transparent;
  border: 1px dashed ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.25)' : '#d1d5db')};
  color: ${({ theme }) => theme.colors.text.secondary};

  &:hover {
    background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : '#f9fafb')};
  }

  & > svg {
    width: 13px;
    height: 13px;
    flex: 0 0 13px;
  }
`;

export const LoaderWrap = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const TooltipList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  max-width: 220px;
`;
